<div class="container-fluid">
  <div class="row">
    @if (loading) {
      <div class="loading-panel col-12">
        <span class="spinner-border spinner-border-sm mr-1"></span>
        <h1>{{ getText('title.advice.analysing') }}</h1>
      </div>
    } @else {
      <div class="content-panel col-12">
        <div class="row mb-5">
          <div class="col-7">
            <h1 class="underline">{{ getText('title.recommendations') }}</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-12 advice-recommendations">
            <p class="col-8 mb-5" tabindex="0" [innerHtml]="getText('general.recommendations')"></p>
          </div>
        </div>
      </div>

    }
  </div>
</div>
@if (!loading) {
  <div class="w-100">
    <div class="rounded-frame">
      @for (option of adviceOptionsConfig; track option) {
        @if (!option.autoAccept) {
          <advice-control #recommendation
                          class="card"
                          [config]="option"
                          [recommendation]="getRecommendation(option!.id!)!"
                          [adviceId]="advice!.adviceId!"
                          [interviewId]="interviewId!"
                          [lastOption]="isLastOption(option)"
                          [prefix]="initiatorType === 'lawfirm' ? initiatorType : 'general'"
                          (interviewCompleteEvent)="completeInterview()"
                          [DEBUG]="DEBUG"
          ></advice-control>
        }
      }
      <div>
        @if (requirementsUnmet) {
          <div class="alert  alert-danger error pill form-error-list">
            <div class="error-list-wrapper" id="err-requirements-unmet" aria-live="assertive">
              <ul>
                <li><span>{{ messages.getText('ADVICE.error.answer-all', 'Please select an answer for each.') }}</span></li>
              </ul>
            </div>
          </div>
        }
        @if (errorSaving) {
          <div class="alert  alert-danger error pill form-error-list">
            <div class="error-list-wrapper" id="err-saving" aria-live="assertive">
              <ul>
                <li><span>{{ messages.getText('ADVICE.error.saving', 'There was an error submitting your decision, please try again.') }}</span></li>
              </ul>
            </div>
          </div>
        }
        <div class="col submit-decisions">
          <button class="btn primary rounded-pill"
                  [disabled]="saving"
                  (click)="completeInterview()">
            {{ messages.getText('ADVICE.button.submit-decisions', 'Submit my decisions') }}
          </button>
        </div>
      </div>
    </div>
  </div>
}
